import { render, staticRenderFns } from "./DevModelTabs.vue?vue&type=template&id=7cc03e47&scoped=true&"
import script from "./DevModelTabs.vue?vue&type=script&lang=js&"
export * from "./DevModelTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc03e47",
  null
  
)

export default component.exports